import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { OrgWorkspaceAccess } from '@nx-frontend/shared/types';

interface GetOrgWorkspaceAccessParams {
  userId: number;
  orgId: string;
  host?: string;
}

export async function getOrgWorkspaceAccess({
  host,
  orgId,
  userId,
}: GetOrgWorkspaceAccessParams): Promise<OrgWorkspaceAccess[] | null> {
  let workspacesAccess: OrgWorkspaceAccess[] | null = null;
  const requestUrl = host || generalEnv.workspaceServiceUrl;

  const response = await axiosClient.get<OrgWorkspaceAccess[]>(`${requestUrl}/v1/orgs/${orgId}/access`, {
    headers: {
      Authorization: `internal ${userId}:auto`,
    },
  });
  workspacesAccess = response.data;

  return workspacesAccess;
}
